<template>
  <div>
    <!-- <GlobalHeader title="Credit Print" style="padding-bottom:5px;" v-show="!show_full_layout"></GlobalHeader> -->
    <b-row class="px-3 border-bottom" v-show="!show_full_layout">
      <b-col cols="12" class="px-0">
        <h2
          class="custom-page-title mb-2 mt-1 px-4"
          style="position:relative;bottom:4px;"
        >Payment Receipt</h2>
      </b-col>
    </b-row>
    <div
      class="sidenav-view-block py-4"
      style="padding-left:17px !important;padding-right:17px !important;overflow-y: scroll;height: calc(100vh - 92px)"
    >
      <b-row style="max-width:1440px">
        <b-col lg="6" xl="4" md="6" sm="6" xs="12" class="mb-4">
          <div
            class="h-100"
            style="box-shadow: rgba(0, 0, 0, 0.09) 0px 0px 0.2cm;position:relative"
          >
            <div
              v-if="active_temp==21"
              class="ribbon text-ellipsis popovercontainer disabled d-print-none"
              style="z-index:3;"
            >
              <div
                style="background-color:#fec44b;border-color:#fec44b"
                class="ribbon-inner font-weight-bold"
              >Active</div>
            </div>
            <Widget class="h-100 mb-0 text-center" title="Standard Template">
              <img
                class="mt-3"
                src="@/assets/print/payment-standard.png"
                style="width:250px;height:350px;display:block;margin-left: auto;margin-right: auto;"
              />
              <div class="mt-3" style="text-align: center;">
                <b-button
                  @click="changeActive(21)"
                  v-if="active_temp!=21"
                  variant="warning"
                  size="xs"
                  class="mb-xs mr-xs"
                  v-b-tooltip.bottom
                  title="Mark as Active"
                >Active</b-button>
                <b-button
                  v-if="RoutePermission(false,'','invoice','settings','templates')"
                  :to="{name:'TemplateUpdate',params:{id:21,path:path},query: { stg_menu:'Payments Received',template_group: 'paymentreceived' } }"
                  variant="outline-default"
                  size="xs"
                  class="mb-xs mr-xs text-dark"
                  v-b-tooltip.bottom
                  title="Edit"
                >
                  <i class="la la-edit la-lg"></i>
                </b-button>
              </div>
            </Widget>
          </div>
        </b-col>
        <b-col lg="6" xl="4" md="6" sm="6" xs="12" class="mb-4">
          <div
            class="h-100"
            style="box-shadow: rgba(0, 0, 0, 0.09) 0px 0px 0.2cm;position:relative"
          >
            <div
              v-if="active_temp==28"
              class="ribbon text-ellipsis popovercontainer disabled d-print-none"
              style="z-index:3;"
            >
              <div
                style="background-color:#fec44b;border-color:#fec44b"
                class="ribbon-inner font-weight-bold"
              >Active</div>
            </div>
            <Widget class="h-100 mb-0 text-center" title="Retail Template">
              <img
                class="mt-3"
                src="@/assets/print/payment-retail.png"
                style="width:250px;height:350px;display:block;margin-left: auto;margin-right: auto;"
              />
              <div class="mt-3" style="text-align: center;">
                <b-button
                  @click="changeActive(28)"
                  v-if="active_temp!=28"
                  variant="warning"
                  size="xs"
                  class="mb-xs mr-xs"
                  v-b-tooltip.bottom
                  title="Mark as Active"
                >Active</b-button>
                <b-button
                  v-if="RoutePermission(false,'','invoice','settings','templates')"
                  :to="{name:'TemplateUpdate',params:{id:28,path:path},query: { stg_menu:'Payments Received',template_group: 'paymentreceived' } }"
                  variant="outline-default"
                  size="xs"
                  class="mb-xs mr-xs text-dark"
                  v-b-tooltip.bottom
                  title="Edit"
                >
                  <i class="la la-edit la-lg"></i>
                </b-button>
              </div>
            </Widget>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import store from "@/store/index";
import Widget from "@/components/Widget/Widget";
export default {
  props: ["show_full_layout", "path"],
  components: {
    Widget
  },

  methods: {
    changeActive(id) {
      store
        .dispatch("settings/activeInvoiceTemp", {
          id: id,
          stg_menu: "Payments Received",
          stg_print: "pymnt_settings_details"
        })
        .then(() => {});
    }
  },
  computed: {
    ...mapState({
      active_temp: state =>
        state.settings.list["Payments Received"].print.templateId
    })
  }
};
</script>

